module.exports = __webpack_public_path__ + "img/link-success.44ab9511.svg";